<template>
  <div class="product-category">
    <div
      class="helloaa"
      v-if="!navigationOptions"
      style="position: relative"
    ></div>
    <div style="height: 16vh" v-if="navigationOptions"></div>
    <div class="titl mt-15 mb-7">
      <h2 class="text-center">تصنيفات أكثر</h2>
    </div>
    <div class="category d-flex justify-center">
      <v-container fluid>
        <v-row class="d-fex justify-center">
          <v-col
            cols="6"
            sm="4"
            md="3"
            lg="2"
            v-for="(categ, i) in category"
            :key="i"
          >
            <v-card class="text-center" elevation="0">
              <v-hover v-slot="{ isHovering, props }">
                <div
                  class="img-parent"
                  style="overflow: hidden; width: 100%; height: 200px"
                  @click="
                    $router.push({
                      name: 'products_category',
                      query: { category: categ.name, title: categ.title },
                    })
                  "
                >
                  <v-img
                    :src="categ.image"
                    v-bind="props"
                    height="200px"
                    :alt="`${categ.name} ميزابووك mizabook`"
                    :style="`cursor: pointer; height: 100% ;transition: 0.4s all ease-in-out; scale: ${
                      isHovering ? 1.05 : 1
                    };`"
                  />
                </div>
              </v-hover>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { useProductsModule } from "@/stores/products";
import { mapActions, mapState } from "pinia";

export default {
  computed: {
    ...mapState(useProductsModule, ["category"]),
  },
  methods: {
    ...mapActions(useProductsModule, ["getProductstop"]),
  },
  mounted() {
    this.getProductstop(); // Call action to fetch products when the component is mounted
  },
  setup() {
    const windowWidth = ref(window.innerWidth); // Reactive windowWidth

    const handleResize = () => {
      windowWidth.value = window.innerWidth; // Update the reactive width
    };

    // Add the resize listener when component is mounted
    onMounted(() => {
      window.addEventListener("resize", handleResize); // Add event listener for resizing
    });

    // Clean up the resize listener before the component is unmounted
    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize); // Clean up the event listener
    });

    // Computed property for navigation options
    const navigationOptions = computed(() => {
      return windowWidth.value <= 1323;
    });

    return {
      navigationOptions,
    };
  },
};
import { ref, onMounted, computed, onBeforeUnmount } from "vue";
</script>

<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");
.product-category {
  margin-top: -81px; /* Adjust the padding-top to match the height of the navbar */
}

.category {
  margin: 0 auto; /* Center align the category div */
}
.titl {
  font-family: "Noto Kufi Arabic", sans-serif;
  font-size: medium;
  font-weight: bold;
}

.helloaa {
  width: 100%;
  height: 180px;
  background-image: url(../assets/helloaa.png);
  background-size: cover;
  background-position: top;
}
</style>
